import { useState } from 'react'
import { percentStopPrice } from '../../lib/setupDetails'

export default function SetupStopInput({ entryPrice, value, onChange, className, disabled = false }) {
  const [error, setError] = useState('')
  const convert = event => {
    if (event.key !== 'Enter' || !String(value).trim().startsWith('-')) return
    event.preventDefault()
    event.stopPropagation()
    try { onChange(percentStopPrice(entryPrice, value)); setError('') }
    catch (failure) { setError(failure.message) }
  }
  return <>
    <input disabled={disabled} aria-label="Stop price" type="text" inputMode="decimal" value={value}
      onChange={event => { setError(''); onChange(event.target.value) }} onKeyDown={convert}
      placeholder="Price or -7.5 ↵" title="Enter a price, or a negative percentage and press Enter (for example -7.5)."
      className={className} />
    {error && <span role="alert" className="block font-mono text-[9px] text-ember">{error}</span>}
  </>
}
